<h1 mat-dialog-title>Update Password</h1>

<form [formGroup]="updatePasswordForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off" autocorrect="off">
	<div mat-dialog-content fxLayout="column" fxAlign="center center">
		<div class="height-auto">
			<div fxLayout="column" fxLayoutGap="20px">

        <mat-form-field *ngIf="data.checkOldPassword">
          <input matInput [placeholder]="'LABEL_PASSWORD_TYPE' | translate : { type: 'Old' }" [formControl]="updatePasswordForm.controls['oldPassword']" [type]="show.old ? 'text' : 'password'">
    
          <mat-icon *ngIf="updatePasswordForm.controls['oldPassword'].value" 
            [svgIcon]="show.old ? 'eye-off' : 'eye'" 
            (click)="show.old = !show.old" 
            matSuffix>
          </mat-icon>
          <mat-error *ngIf="updatePasswordForm.controls['oldPassword'].hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['oldPassword'].hasError('invalidPassword')">
            Invalid Password
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['oldPassword'].hasError('minlength')">
            Password must be at least 8 characters
          </mat-error>
        </mat-form-field>


        <mat-form-field>
          <input matInput [placeholder]="'LABEL_PASSWORD_TYPE' | translate : { type: 'New' }" minlength="8" maxlength="60" [formControl]="updatePasswordForm.controls['password']" [type]="show.password ? 'text' : 'password'">
          
          <mat-icon *ngIf="updatePasswordForm.controls['password'].value" 
            [svgIcon]="show.password ? 'eye-off' : 'eye'" 
            (click)="show.password = !show.password" 
            matSuffix>
          </mat-icon>

          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('minlength')">
            Password must be at least 8 characters
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('maxlength')">
            New Password should be at most 60 characters long
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('pattern')">
            Password must include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('invalidPassword')">
            Invalid Password
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('matchOldPassword')">
            Passwords do not match
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('reusedPassword')">
            Password has already been used. Pick a different one.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput [placeholder]="'LABEL_PASSWORD_TYPE' | translate : { type: 'Confirm' }" [formControl]="updatePasswordForm.controls['confirmPassword']" [type]="show.confirm ? 'text' : 'password'">
    
          <mat-icon *ngIf="updatePasswordForm.controls['confirmPassword'].value" 
            [svgIcon]="show.confirm ? 'eye-off' : 'eye'" 
            (click)="show.confirm = !show.confirm" 
            matSuffix>
          </mat-icon>
          <mat-error *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('matchPassword')">
            Passwords do not match
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('invalidPassword')">
            Invalid Password
          </mat-error>
          <mat-error *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('reusedPassword')">
            Password has already been used. Pick a different one.
          </mat-error>
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="20px">
          <button fxFlex mat-button (click)="dialogRef.close()" type="button"> {{ 'LABEL_CANCEL' | translate }} </button>
          <button color="primary" fxFlex mat-raised-button type="submit" [disabled]="!updatePasswordForm.valid">Update</button>
        </div>
			</div>
		</div>
	</div>
</form>